module.exports = __webpack_public_path__ + "aa81de22ebb7e09e45ead6c4aab2a9d5.png";